import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';

export type PendoInitializationOptions = {
  visitor: {
    id: string;
  };
  account: {
    id: string;
  };
};

const { VITE_APP_PENDO_PUBLIC_KEY, NODE_ENV } = import.meta.env;

export const PendoManager = () => {
  const { user } = useAuth0();
  const userEmail = user?.email;

  useEffect(() => {
    if (!userEmail || !VITE_APP_PENDO_PUBLIC_KEY || NODE_ENV === 'test') {
      console.warn('Pendo not initialized');
      return;
    }

    const pendoParams = {
      visitor: { id: userEmail },
      account: { id: 'abyss-fabric-v2' },
    };
    window?.pendo?.initialize(pendoParams);
  }, [userEmail]);

  return null;
};
